export default __webpack_public_path__ + "static/media/detail_small_5_3.2cb003ff.png";